import React, {useEffect, useState} from 'react';
import { Loader } from "semantic-ui-react";
import { size, map } from "lodash";
import { PaymentCategory } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { PaymentCategoryItem } from "../PaymentCategoryItem";

const paymentCategoryController = new PaymentCategory();

export function ListPaymentCategory(props) {

  const { status, reload, onReload } = props;
  const [paymentCategories, setPaymentCategories] = useState(null);
  const { accessToken } = useAuth();

  useEffect(() => {
    (async () => {
      try {
        setPaymentCategories(null);
        const response = await paymentCategoryController.getPaymentCategories(accessToken, status);
        setPaymentCategories(response);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [status, reload]);

  if (!paymentCategories) return <Loader active inline="centered" />;
  if (size(paymentCategories) === 0) return "No existen categorías de pago registradas";

  return map(paymentCategories, (paymentCategory) => (
    <PaymentCategoryItem key={paymentCategory.id} paymentCategory={paymentCategory} onReload={onReload} />
  ));
}
